<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <!-- <el-row class="table-header">
          <el-col>
            <el-tooltip effect="dark" content="创建配置" placement="top-start"  v-if="userPermissions.indexOf('openapi_server_create') != -1 && buttonType=='icon'" >
              <el-button type="primary" size="medium" icon="iconfont icon-tianjiacaidan2" @click="addButton(0)"></el-button>
            </el-tooltip>
            <el-button type="primary" size="medium" icon="iconfont"  v-if="userPermissions.indexOf('openapi_server_create') != -1 && buttonType=='text'"  @click="addButton(0)">创建配置</el-button>
          </el-col>
        </el-row> -->
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <!-- <el-form-item label="ID">
              <el-input v-model="searchCondition.id" placeholder="输入ID" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="名称">
              <el-input v-model="searchCondition.name" placeholder="输入名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable ref="apeTable" :data="openapi_serverList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <!-- <el-table-column
            v-if="buttonType=='text'"
            width="160"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('openapi_server_view') != -1"  @click="viewButton(scope.row.id)">详情</el-button>
                <el-button size="mini" type="default" v-if="userPermissions.indexOf('openapi_server_edit') != -1"  @click="editButton(scope.row.id)">编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('openapi_server_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini">删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column> -->
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="dialogRules" ref="openapi_serverAttacmentForm" label-position="right" label-width="96px">
          <el-form-item label="名称" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="attachment">
            <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="attachmentType" @handleUploadSuccess="handleAttachmentUploadSuccess" @handleUploadRemove="handleAttachmentUploadRemove" :upload-file-list="attachmentUploadFileList"></ApeUploader>
          </el-form-item>
          <el-form-item label="备注" prop="intro">
            <el-input type="textarea" v-model="formData.intro"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker
  },
  data() {
    return {
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      columns: [
        {
          title: 'ID',
          value: 'id',
          header_align: 'center',
          align: 'center',
          width: 170
        },
        {
          title: '名称',
          header_align: 'center',
          align: 'center',
          value: 'name',
        },
        {
          title: 'SERVER',
          width: 170,
          header_align: 'center',
          align: 'center',
          value: [
            {label:'',value:'server'},
          ],
        },
        {
          title: '创建时间',
          header_align: 'center',
          align: 'center',
          value: 'created_at',
          width: 200
        },
        {
          title: '更新时间',
          header_align: 'center',
          align: 'center',
          value: 'created_at',
          width: 200
        }
      ],
      // 表格列表数据
      openapi_serverList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentOpenapiServerId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.initOpenapiServerList()
      }
    }
  },
  methods: {
    // 搜索
    searchButton() {
      this.initOpenapiServerList('search')
    },
    // 切换页码操作
    async switchPaging() {
      this.initOpenapiServerList()
    },
    // 响应添加按钮
    async addButton() {
      this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    // 响应编辑按钮
    async editButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteOpenapiServer(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initOpenapiServerList('del')
        })
      } else {
        this.$message.error(info)
      }

    },
    // 文章添加附件
    openapi_serverAttachment(row) {
      this.currentOpenapiServerId = row.id
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '附件列表（'+row.title+'）'
      this.initOpenapiServerAttachmentList()
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
    // 初始化文章列表
    async initOpenapiServerList(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getOpenapiServerList(searchCondition)
      this.openapi_serverList = []
      this.$nextTick(() => {
        this.openapi_serverList=list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      // if (this.searchCondition.id) {
      //   condition.id = this.searchCondition.id
      // }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }

      return condition
    },
    // 获取文章分类列表
    async getCategoryList() {
      // 获取文章分类列表
      let {list} = await this.$api.getOpenapiServerCategoryList()
      this.searchCategory = list
    },
    // 初始化文件附件列表
    async initOpenapiServerAttachmentList() {
      let list = await this.$api.getOpenapiServerAttachment(this.currentOpenapiServerId)
      this.attachmentList = list
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment_id = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment_id = 0
      this.attachmentUploadFileList = fileList
    },
    // form数据提交，请求接口,文章附件
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.openapi_server_id = this.currentOpenapiServerId
      let id = await this.$api.saveOpenapiServerAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initOpenapiServerAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['openapi_serverAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteOpenapiServerAttachmentButton(id) {
      let info = await this.$api.deleteOpenapiServerAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initOpenapiServerAttachmentList()
        })
      } else {
        this.$message.error(info)
      }

    },
    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },

  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.initOpenapiServerList()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  // .table-search
  //   height: 36px
</style>
